import React from 'react';

const WhyChooseUsSection: React.FC = () => {
  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">農業のプロに選ばれる3つの理由</h2>
          <p className="text-xl sm:text-lg text-gray-600">なぜ多くの農業従事者がIDS教習所グループを選ぶのか</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow h-full flex flex-col">
            <div className="w-24 h-24 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-4xl font-bold text-[#76B947]">01</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-[#2A6041] mb-4 min-h-[4rem] flex items-center justify-center">
              お客様にあわせた<br />「最適提案力」
            </h3>
            <p className="text-gray-600 sm:text-lg leading-relaxed flex-1">
              DJI、FJD、EFIXなど複数社の製品から、お客様の課題、圃場と予算に本当に合ったベストな製品を中立的な立場でご提案します。
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow h-full flex flex-col">
            <div className="w-24 h-24 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-4xl font-bold text-[#76B947]">02</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-[#2A6041] mb-4 min-h-[4rem] flex items-center justify-center">
              導入後も安心の<br />「地域密着サポート」
            </h3>
            <p className="text-gray-600 sm:text-lg leading-relaxed flex-1">
              佐賀・鹿児島に拠点を構え、操作指導から点検・整備、急なトラブルまで専門スタッフが迅速に対応します。「売りっぱなし」には絶対にしません。
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow h-full flex flex-col">
            <div className="w-24 h-24 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-4xl font-bold text-[#76B947]">03</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-[#2A6041] mb-4 min-h-[4rem] flex items-center justify-center">
              資格取得まで可能な<br />「一貫体制」
            </h3>
            <p className="text-gray-600 sm:text-lg leading-relaxed flex-1">
              製品販売だけでなく、農業ドローン協議会認定のスクールも運営。購入から操縦士の育成まで、すべてIDSにお任せいただけます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
